"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
const _excluded = ["title", "description"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const shopbrand03 = _ref => {
  let {
      title,
      description
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 72 66",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? "title-shopbrand03" : '') + (description ? " desc-shopbrand03" : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-shopbrand03"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-shopbrand03"
  }, description), /*#__PURE__*/_react.default.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M61.089 65.996H16.285a4.448 4.448 0 0 1-4.559-3.685l-6.35-44.318a4.33 4.33 0 0 1 1.266-3.3 4.3 4.3 0 0 1 3.297-1.248h57.496a4.297 4.297 0 0 1 3.296 1.248c.87.87 1.33 2.07 1.263 3.3l-6.35 44.318a4.448 4.448 0 0 1-4.555 3.685Z",
    fill: "#FFB499",
    fillOpacity: ".5"
  }), /*#__PURE__*/_react.default.createElement("g", {
    fill: "#F04C24"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.095 64.534H56.86a5.448 5.448 0 0 0 5.565-4.543l6.35-44.318.008-.087a5.327 5.327 0 0 0-1.555-4.063 5.297 5.297 0 0 0-4.031-1.54H5.758a5.3 5.3 0 0 0-4.031 1.54 5.33 5.33 0 0 0-1.558 4.062c.002.03.005.059.009.088L6.527 59.99l.005.03a5.448 5.448 0 0 0 5.563 4.513Zm-3.59-4.843-6.34-44.255a3.33 3.33 0 0 1 .974-2.497 3.3 3.3 0 0 1 2.59-.956h57.529l.028-.002c.94-.057 1.86.291 2.53.958a3.327 3.327 0 0 1 .972 2.496l-6.34 44.256a3.448 3.448 0 0 1-3.569 2.843H12.035a3.448 3.448 0 0 1-3.53-2.843Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M34.428.158c6.202.02 11.516 4.444 12.681 10.549l.188.982-1.965.375-.187-.982c-.987-5.167-5.482-8.906-10.72-8.924-5.21.025-9.683 3.732-10.688 8.868l-.192.981-1.963-.384.192-.981C22.96 4.574 28.25.185 34.42.158h.007Z"
  }))));
};
var _default = exports.default = shopbrand03;